import { getItem } from "./cooke-data";

export function getPermissions() {
  return getItem("permissions");
}

export function getRoles() {
  return getItem("userRole");
}

export function checkPermissions(moduleName, isNavigation = false) {
  const permissions = getPermissions() || [];

  if (isNavigation) {
    const isMemoModule = moduleName.endsWith("_MEMO");
    const baseModule = moduleName.replace("_MEMO", "");

    if (isMemoModule) {
      return permissions.some(
        (p) =>
          p === moduleName ||
          (typeof p === "string" && p.startsWith(`${moduleName}_`)) ||
          (typeof p === "string" && p.startsWith(`${baseModule}_MEMO_`))
      );
    } else {
      return (
        permissions.some(
          (p) =>
            p === moduleName && !(typeof p === "string" && p.includes("_MEMO"))
        ) ||
        permissions.some(
          (p) =>
            typeof p === "string" &&
            p.startsWith(`${moduleName}_`) &&
            !(typeof p === "string" && p.includes("_MEMO_"))
        )
      );
    }
  }

  return permissions?.includes(moduleName);
}
